module.exports = __webpack_public_path__ + "img/badge-1.35b68ae5.png";